export var _toLazyIndexed = function (fn) {
    fn.indexed = true;
    return fn;
};
